module.exports = "../../../../platform/assets/pageMainIcon/danjuweihulei2.svg";